"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3430],{

/***/ 83001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "YS": function() { return /* reexport */ DataVisualization_Caption_Caption; },
  "dk": function() { return /* reexport */ DataVisualization_Description_Description; },
  "Bc": function() { return /* reexport */ DataVisualization_Figure_Figure; },
  "X6": function() { return /* reexport */ Heading_Heading; },
  "Ee": function() { return /* reexport */ DataVisualization_Image_Image; },
  "ZP": function() { return /* reexport */ DataVisualization_DataVisualization; }
});

// UNUSED EXPORTS: Divider

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/DataVisualization.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var DataVisualization_views_DataVisualization = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1rrkkc30"
} : 0)( true ? {
  name: "43cxha",
  styles: "display:flex;flex-direction:column;gap:32px"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/DataVisualization.tsx


var _excluded = ["appearance", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var DataVisualization = function DataVisualization(_ref) {
  var externalAppearance = _ref.appearance,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: appearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DataVisualization_views_DataVisualization, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }))
  });
};

/* harmony default export */ var DataVisualization_DataVisualization = (DataVisualization);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Heading/Heading.views.ts


function Heading_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Heading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e1iovxur0"
} : 0)( true ? {
  name: "1mlhnwm",
  styles: "margin-top:0;margin-bottom:8px"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Heading/Heading.tsx


var Heading_excluded = ["children", "tokens"];

function Heading_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Heading_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Heading_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Heading_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var DataHeading = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Heading_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, Heading_objectSpread(Heading_objectSpread({
    ref: ref,
    variant: "h4",
    tag: "h4",
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
/* harmony default export */ var Heading_Heading = (DataHeading);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Heading/index.ts

// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Figure/Figure.views.ts

var Figure = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("figure",  true ? {
  target: "ew7uk8a0"
} : 0)("display:flex;flex-direction:column;gap:", function (_ref) {
  var gap = _ref.gap;
  return gap;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Figure/Figure.tsx


var Figure_excluded = ["children", "tokens"];

function Figure_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Figure_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Figure_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Figure_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseFigure = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Figure_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Figure, Figure_objectSpread(Figure_objectSpread(Figure_objectSpread({
    ref: ref
  }, tokens), rest), {}, {
    children: children
  }));
});
var Figure_Figure = (0,useDesignTokens/* withDesignTokens */.Y)(BaseFigure, function () {
  return {
    gap: "32px"
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  }
});
/* harmony default export */ var DataVisualization_Figure_Figure = (Figure_Figure);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Figure/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Media/index.ts + 2 modules
var Media = __webpack_require__(75091);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Image/Image.views.tsx

var Root = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1w5j7bz1"
} : 0)( true ? "" : 0);
var MediaWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1w5j7bz0"
} : 0)( true ? "" : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Image/Image.tsx



var Image_excluded = ["sources", "alt"];

function Image_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Image_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Image_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Image_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function Image_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}






var breakpoints = ["xs", "sm", "md", "lg", "xl", "xxl"];

var Image_Image = function Image(_ref) {
  var sources = _ref.sources,
      alt = _ref.alt,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Image_excluded);

  var renderMedia = (0,react.useMemo)(function () {
    return function (key, array, index) {
      var defaultProps = {
        src: sources[key].name,
        width: sources[key].width,
        height: sources[key].height
      };
      var isClose = breakpoints.toString().includes("".concat(key, ",").concat(array[index + 1]));
      var isLast = array[array.length - 1] === key;
      var previousBreakPoint = breakpoints[breakpoints.indexOf(array[index + 1]) - 1];

      if (isLast) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
          greaterThanOrEqual: key,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FitCover, Image_objectSpread(Image_objectSpread({}, rest), {}, {
            alt: alt || "",
            loading: "lazy"
          }, defaultProps))
        }, key);
      }

      if (isClose) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
          at: key,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FitCover, Image_objectSpread(Image_objectSpread({}, rest), {}, {
            alt: alt || "",
            loading: "lazy"
          }, defaultProps))
        }, key);
      }

      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Media/* default */.Z, {
        between: [key, previousBreakPoint],
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FitCover, Image_objectSpread(Image_objectSpread({}, rest), {}, {
          alt: alt || "",
          loading: "lazy"
        }, defaultProps))
      }, key);
    };
  }, [alt, sources, rest]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Root, {
    children: Object.keys(sources).length ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MediaWrapper, {
      children: Object.keys(sources).map(function (key, index, array) {
        return renderMedia(key, array, index);
      })
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FitCover, Image_objectSpread(Image_objectSpread({}, rest), {}, {
      alt: alt || "",
      loading: "lazy",
      src: sources.src.name,
      width: sources.src.width,
      height: sources.src.height
    }))
  });
};

var FitCover = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e7shmoi0"
} : 0)( true ? {
  name: "1vfhcql",
  styles: "object-fit:cover"
} : 0);

/* harmony default export */ var DataVisualization_Image_Image = (Image_Image);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Image/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Caption/Caption.views.ts


function Caption_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Caption = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e18oeupk0"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Caption/Caption.tsx


var Caption_excluded = ["children", "tokens"];

function Caption_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Caption_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Caption_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Caption_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseCaption = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Caption_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Caption, Caption_objectSpread(Caption_objectSpread({
    ref: ref,
    tag: "figcaption",
    variant: "textTiny",
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
var Caption_Caption = (0,useDesignTokens/* withDesignTokens */.Y)(BaseCaption, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[50]
    };
  }
});
/* harmony default export */ var DataVisualization_Caption_Caption = (Caption_Caption);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Caption/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Description/Description.views.ts


function Description_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "euoz1230"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Description/Description.tsx


var Description_excluded = ["children", "tokens"];

function Description_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Description_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Description_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Description_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Description_Description = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Description_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, Description_objectSpread(Description_objectSpread({
    ref: ref,
    tag: "p",
    variant: "pLarge",
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
/* harmony default export */ var DataVisualization_Description_Description = (Description_Description);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Description/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Divider/index.ts + 1 modules
var Divider = __webpack_require__(76305);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Divider/Divider.views.ts


var Divider_views_Divider = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Divider/* default */.Z,  true ? {
  target: "e4mokqr0"
} : 0)( true ? "" : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Divider/Divider.tsx


var Divider_excluded = ["tokens"];

function Divider_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Divider_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Divider_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Divider_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var BaseDivider = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Divider_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider_views_Divider, Divider_objectSpread({
    ref: ref,
    tokens: tokens
  }, rest));
});
var Divider_Divider = (0,useDesignTokens/* withDesignTokens */.Y)(BaseDivider, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[300]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[20]
    };
  }
});
/* harmony default export */ var DataVisualization_Divider_Divider = (Divider_Divider);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/Divider/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/DataVisualization/index.ts







DataVisualization_DataVisualization.displayName = "DataVisualizationBase";
Heading_Heading.displayName = "DataVisualization.Heading";
DataVisualization_Figure_Figure.displayName = "DataVisualization.Figure";
DataVisualization_Description_Description.displayName = "DataVisualization.Description";
DataVisualization_Image_Image.displayName = "DataVisualization.Image";
DataVisualization_Caption_Caption.displayName = "DataVisualization.Caption";
DataVisualization_Divider_Divider.displayName = "DataVisualization.Divider";


/***/ }),

/***/ 34810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/SegmentLogo/index.ts + 2 modules
var SegmentLogo = __webpack_require__(84672);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/index.ts + 4 modules
var recipes_Footer = __webpack_require__(80653);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Footer/data.ts
var Footer_data = __webpack_require__(52661);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var BrandLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed41syo0"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Footer/Footer.tsx


var _excluded = ["appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}












var Footer = function Footer(_ref) {
  var appearance = _ref.appearance,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var pageConfig = (0,page/* usePageConfig */.Gm)();
  var footerAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var ctaText = "See how it works";
  var data = (0,Footer_data/* default */.Z)(pageConfig);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Footer/* default */.Z, _objectSpread({
    bottomLinks: data.bottomLinks,
    mainLinks: data.mainLinks,
    copyright: data.copyright,
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
      appearance: footerAppearance,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: (0,getAbsoluteUrl/* default */.Z)("/", pageConfig),
        passHref: true,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BrandLink, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SegmentLogo/* default */.Z, {
            alt: "Twilio, Inc.",
            footer: true
          })
        })
      })
    }),
    cta: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      color: "primary",
      variant: "filled",
      size: "large",
      href: (0,getAbsoluteUrl/* default */.Z)("/demo/", pageConfig),
      children: ctaText
    }),
    appearance: appearance
  }, props));
};

/* harmony default export */ var Footer_Footer = (Footer);

/***/ }),

/***/ 52661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43848);


var getData = function getData(pageConfig) {
  return {
    logo: {
      src: "/images/SegmentLogoWhite.png",
      srcSet: "/images/SegmentLogoWhite@2x.png 2x",
      alt: "Twilio, Inc.",
      width: 300,
      height: 65
    },
    bottomLinks: [{
      url: "https://www.twilio.com/legal/privacy/",
      title: "Privacy policy"
    }, {
      url: "https://www.twilio.com/legal/tos/",
      title: "Terms of Service"
    }],
    mainLinks: [{
      title: "Products",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/connections/", pageConfig),
        title: "Connections"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/protocols/", pageConfig),
        title: "Protocols"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/unify/", pageConfig),
        title: "Unify"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/twilio-engage/", pageConfig),
        title: "Twilio Engage"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/customer-data-platform/", pageConfig),
        title: "Customer Data Platform",
        rel: "nofollow"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/catalog/", pageConfig),
        title: "Integrations Catalog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/pricing/", pageConfig),
        title: "Pricing"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/security/", pageConfig),
        title: "Security"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/product/gdpr/", pageConfig),
        title: "GDPR"
      }]
    }, {
      title: "For Developers",
      links: [{
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://docs.segmentapis.com/",
        title: "Segment API"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/developer-portal/", pageConfig),
        title: "Build on Segment"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/opensource/", pageConfig),
        title: "Open Source"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/engineering/", pageConfig),
        title: "Engineering Team"
      }]
    }, {
      title: "Company",
      links: [{
        url: "https://www.twilio.com/company/jobs/",
        title: "Careers"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/blog/", pageConfig),
        title: "Blog"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("https://segment.com/newsroom/", pageConfig),
        title: "Press"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/events/", pageConfig),
        title: "Events"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/good-data-better-marketing/", pageConfig),
        title: "Podcast"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/growth-center/", pageConfig),
        title: "Growth Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/data-hub/", pageConfig),
        title: "Data Hub"
      }]
    }, {
      title: "Support",
      links: [{
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/help/", pageConfig),
        title: "Help Center"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/contact/", pageConfig),
        title: "Contact us"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/", pageConfig),
        title: "Resources"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/recipes/", pageConfig),
        title: "Recipes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/services/", pageConfig),
        title: "Professional Services"
      }, {
        url: "https://segment.com/security/bulletins/",
        title: "Security Bulletins"
      }, {
        url: "https://segment.com/docs/",
        title: "Documentation"
      }, {
        url: "https://segment.com/release-notes/",
        title: "Release Notes"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/partners/", pageConfig),
        title: "Become a Partner"
      }, {
        url: (0,_segment_utils_getAbsoluteUrl__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("/resources/cdp/", pageConfig),
        title: "Guide to Customer Data Platforms"
      }]
    }],
    copyright: "\xA9 ".concat(new Date().getUTCFullYear(), " Twilio Inc. All Rights Reserved.")
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (getData);

/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ })

}]);